import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { AuthShell, Field } from "../components/AuthShell";
import { API_BASE } from "../services/api";

function getApiError(data, fallback) {
  if (typeof data?.detail === "string") return data.detail;
  if (Array.isArray(data?.detail)) {
    return data.detail.map((item) => item.msg).filter(Boolean).join(", ") || fallback;
  }
  return fallback;
}

export default function SignIn() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ username: "", password: "" });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handle = (e) => setForm((f) => ({ ...f, [e.target.name]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (!form.username || !form.password) {
      setError("Please fill in all fields.");
      return;
    }

    setError("");
    setLoading(true);

    try {
      const res = await fetch(`${API_BASE}/api/auth/login`, {
        method: "POST",
        headers: {
          accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          username: form.username.trim(),
          password: form.password,
        }),
      });

      const data = await res.json().catch(() => null);
      if (!res.ok) {
        throw new Error(getApiError(data, "Unable to sign in."));
      }

      localStorage.setItem("access_token", data.access_token);
      localStorage.setItem("auth_user", JSON.stringify(data));
      navigate("/visualizer");
    } catch (err) {
      setError(err.message || "Unable to sign in.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      title="Welcome back"
      subtitle="Sign in to your account to continue"
      onSubmit={submit}
      error={error}
      loading={loading}
      submitLabel="Sign In"
      footer={null}
    >
      <Field
        label="Username" id="username" placeholder="krishna"
        value={form.username} onChange={handle} autoComplete="username"
      />
      <Field
        label="Password" id="password" type="password" placeholder="••••••••"
        value={form.password} onChange={handle} autoComplete="current-password"
        extra={<a href="#/" className="text-xs text-accent2 hover:text-accent transition-colors">Forgot password?</a>}
      />
    </AuthShell>
  );
}
